import React, { useEffect, useState } from "react";
import "./profile.scss";
import Image from "next/image";
import profile from "@/../public/profile/profile.png";
import img from "@/../public/profile/img.png";
import close from "@/../public/credits/close.png";
import { getAuth, signOut, onAuthStateChanged } from "firebase/auth";
import { useRouter } from "next/navigation";
import UserDB from "@/utils/userdb";
import { IoMdCheckbox } from "react-icons/io";
import { MdCancel } from "react-icons/md";
import { MdDelete } from "react-icons/md";
import { FaDownload } from "react-icons/fa6";
import { useDispatch } from "react-redux";
import { UserData } from "@/app/redux/slice";
import axios from "axios";

import Delete from "./delete";

export default function Profile({
  user,
  setIsProfileOpen,
  gallaryArr,
  getAllImages,
}) {
  // const [contact, setContact] = useState();
  const router = useRouter();
  const [select, setSelect] = useState(false);
  const [selectedImages, setSelectedImages] = useState([]);
  const [downloadSelectedImgs,setDownloadSelectedImgs]=useState([]);
  const [isDelete, setIsDelete] = useState(false);
  const dispatch = useDispatch();
  const [isLoading,setIsLoading]=useState();

  // console.log(JSON.stringify(select));

  const logOutClickHandler = () => {
    const auth = getAuth();
    signOut(auth)
      .then(() => {
        dispatch(UserData(null));
        // Sign-out successful.
        router.push("/");
      })
      .catch((error) => {
        // An error happened.
      });
    localStorage.removeItem("isUserLoggedIn");
  };

  let contact;
  if (user.email) {
    contact = user.email;
  } else {
    contact = user.phoneNumber;
  }

  const downloadImageHandler = (event) => {
    axios
      .post(UserDB.getServerURI() + "/image/createZip", {
        userId: UserDB.getUser()._id,
        images: JSON.stringify(downloadSelectedImgs),
      })
      .then((response) => {
        if (response.data.status == "success") {
          if (window)
            window.open(
              UserDB.getServerURI() +
                "/image/download/" +
                UserDB.getUser()._id +
                "/" +
                response.data.fileName
            );
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleImageSelect = (id,path) => {
    if (selectedImages.includes(id)) {
      setSelectedImages(selectedImages.filter((i) => i !== id));
    } else {
      // let obj = { path: path };
      setSelectedImages([...selectedImages, id]);
    }
    
    if(downloadSelectedImgs.includes(path)){
      setDownloadSelectedImgs(downloadSelectedImgs.filter((i) => i !== path));
    }else{
      setDownloadSelectedImgs([...downloadSelectedImgs, path]);
    }
  };

  const handleSelectAll = () => {
    const allImageIds = gallaryArr.map((item) => item._id);
    const allImagePaths = gallaryArr.map((item) => item.path);
    setSelectedImages(allImageIds);
    setDownloadSelectedImgs(allImagePaths);
  };
  
  const handleCancelAll = () => {
    setSelectedImages([]);
    setDownloadSelectedImgs([]);
  };

  const handleDeleteSelected = async () => {
    if (selectedImages.length > 0) {
      const url =
        UserDB.getServerURI() + "/image/delete-selected-gallery-images";
      try {
        setIsLoading(true)
        let res = await axios.delete(url, { data: { ids: selectedImages } });
        if (user) {
          getAllImages();
        }
        if (res.status == 200) {
          setIsDelete(false);
        }
        setIsLoading(false)
      } catch (err) {
        setIsLoading(false)
        console.log(err);
      }
    }
  };

  // console.log(JSON.stringify(selectedImages));
  // console.log(selectedImages);

  return (
    <div className="Profile">
      <div className="user">
        <div className="userProfile">
          <Image
            className="userProfileImg"
            width={100}
            height={100}
            // className={styles.userProfileImg}
            src={user.photoURL}
            alt="profile-picture"
          />
        </div>
        <div className="rightContainer">
          <div className="contact">
            <p>
              snap
              {user._id
                .substr(user._id.length - 4, user._id.length)
                .toLowerCase()}
            </p>
            <p
              className={`phoneEmail  ${contact.length > 19 ? "bigEmail" : ""}`}
            >
              {user.email ? user.email : user.phoneNumber}
            </p>
          </div>
          {/* <button className={`btn1 ${styles.btn}`}>Edit Profile</button> */}
        </div>
      </div>
      <div className="gallery">
        <div className="top">
          <p className="txt">Gallery</p>
          {gallaryArr.length > 0 && (
            <div className="select">
              <input
                type="checkbox"
                id="select"
                onChange={(e) => setSelect(e.target.checked)}
                checked={select}
                className="input"
              />
              <label htmlFor="select" className="label">
                {select ? "Select" : "Select to Download or Delete"}
              </label>
            </div>
          )}
          {select && (
            <div className="flex-row-center download">
              <div onClick={handleCancelAll} className="cancel">
                <MdCancel />
              </div>
              <div
                onClick={handleSelectAll}
                className="flex-row-center selectAll"
              >
                Select All
              </div>
              <div className="downloadBtn" onClick={downloadImageHandler}>
                <FaDownload />
              </div>
              <div
                className="deleteBtn"
                onClick={() => {
                  selectedImages.length !== 0 && setIsDelete(true);
                }}
              >
                <MdDelete />
              </div>
            </div>
          )}
        </div>
        <div className="flex-row-center bottom">
          {gallaryArr?.map((item, index) => (
            <div key={index} className="imgContainer">
              <a
                href={UserDB.getServerURI() + "/" + item.path}
                target="_blank"
                className="a"
                onClick={(e) => {
                  if (select) {
                     e.preventDefault();
                      handleImageSelect(item._id,item.path)
                  }
                }}
              >
                <Image
                  src={UserDB.getServerURI() + "/" + item.path}
                  width={150}
                  height={150}
                  alt="img"
                  className="img"
                  // onClick={downloadImageHandler}
                />
                {select && (
                  <div className="selectImgInputBox">
                  <input
                    type="checkbox"
                    className="selectImg"
                    onClick={(e) => e.stopPropagation()}
                    onChange={() => handleImageSelect(item._id,item.path)}
                    checked={selectedImages.includes(item._id)}
                  />
                  </div>
                )}
              </a>
            </div>
          ))}
        </div>
        {/* {gallaryArr.length == 0 ? "" : <p className={styles.seeAll}>See All</p>} */}
      </div>
      <p className="msg">Gallery images are auto-deleted after 72 hours</p>
      <p className="logout" onClick={logOutClickHandler}>
        Log Out
      </p>

      {/* close */}
      <div
        onClick={() => {
          setIsProfileOpen(false);
        }}
        className="close"
      >
        <Image width={100} height={100} src={close} alt="close" />
      </div>

      {/* delete */}
      {isDelete && (
        <Delete
          setIsDelete={setIsDelete}
          handleDeleteSelected={handleDeleteSelected}
          isLoading={isLoading}
        />
      )}
    </div>
  );
}
